import React from 'react';
import gql from 'graphql-tag';

import client from '../../../utils/apolloClient';

const cancellationChargeByBookingMutation = gql`
  mutation cancellationChargeByBookingMutation(
    $input: CancellationChargeByBookingInput
  ) {
    cancellation_charge_by_booking(input: $input) {
      cancellation_charges
      eligible_refund_type
      eligible_refund
    }
  }
`;

const cancellationChargeByBooking = async ({ input }) => {
  try {
    const data = await client.clientPrivate.mutate({
      client: client.clientPrivate,
      mutation: cancellationChargeByBookingMutation,
      variables: {
        input,
      },
    });

    if (data && data?.data?.cancellation_charge_by_booking) {
      return data.data.cancellation_charge_by_booking;
    }
    return null;
  } catch {
    return null;
  }
};

export const useCancellationChargeByBooking = ({ input }) => {
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState(null);

  React.useEffect(() => {
    const fetchFunc = async () => {
      setLoading(true);
      const res = await cancellationChargeByBooking({ input });
      setData(res);
      setLoading(false);
    };

    if (input?.table_booking_id && input?.user_id) {
      fetchFunc();
    } else {
      setLoading(false);
    }
  }, [input?.table_booking_id, input?.user_id]);

  return [loading, data];
};

export default {};
